import { render } from "./RelationshipPanel.vue?vue&type=template&id=0e6da7c5"
import script from "./RelationshipPanel.vue?vue&type=script&lang=js"
export * from "./RelationshipPanel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nazikban/projects/credit-west-second/packages/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"RelationshipPanel.vue"]])

export default __exports__